export default function (state = false, action) {
    switch (action.type) {
        case 'LOGIN_TOGGLE':
            return action.payload;
        default: 
            return state;
    }
}